import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const Material = () => {
  useDocumentTitle("Material | T360");

  return (
    <div>Material</div>
  )
}

export default Material